// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
let _;
if (typeof window === 'undefined') {

    _ = require('lodash');

    RivalIQ = {
        utils: {}
    };

    RivalIQ.utils.email = module.exports;

} else {
    RivalIQ = window.RivalIQ;
    _ = window._;

    RivalIQ.module('utils', function (utils) {
        'use strict';

        utils.email = {};
    });
}

(function (email) {
    'use strict';

    email.validEmailAddress = function (email) {

        // must exist and meet minimum size
        if (!_.isString(email) || _.size(email) < _.size('a@b.c')) {
            return false;
        }

        // must not have whitespace
        const whitespace = /\s/;
        if (whitespace.test(email)) {
            return false;
        }

        // must have one @
        const parts = email.split('@');
        if (_.size(parts) !== 2) {
            return false;
        }

        // must have a name
        if (!_.size(parts[0])) {
            return false;
        }

        // name can't have invalid chars
        const invalidNameChars = /[;,]/;
        if (invalidNameChars.test(parts[0])) {
            return false;
        }

        // must have a domain
        if (!_.size(parts[1])) {
            return false;
        }

        // domains can't have invalid chars
        const invalidDomainChars = /[+><;,]/;
        if (invalidDomainChars.test(parts[1])) {
            return false;
        }

        // domain must have at least one .
        const domainParts = parts[1].split('.');
        if (_.size(domainParts) < 2) {
            return false;
        }

        // domain parts must all exist (no double dots)
        if (_.maxBy(domainParts, _.size) < 1) {
            return false;
        }

        // use the super regex from https://emailregex.com/
        return (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(email);
    };


})(RivalIQ.utils.email);
